




import {Vue, Component} from 'vue-property-decorator';
import {GetInstagramTokenRequest} from 'ncp-api-supporter/dist/types/modules/manage/instagram';

@Component
export default class InstagramCodeReceiver extends Vue {
	created() {
		const code = typeof this.$route.query.code === 'string' ? this.$route.query.code : '';
		
		const openerPaths = window.opener.location.pathname.split('/');
		
		const mallNo = Number(openerPaths[openerPaths.length - 1]);
		
		this.connectInstagram(code, mallNo).then(() => {
			window.opener.location.reload()
			window.close()
		}).catch(() => {
			alert('인스타그램 연동에 실패하였습니다. 다시 연동해주세요.')
			window.close()
		})
	}
	
	connectInstagram(code: string, mallNo: number) {
		const request: GetInstagramTokenRequest = {
			params: {
				mallNo,
				code,
				redirectUri: location.origin + location.pathname
			}
		}
		
		return this.$api.getInstagramToken(request)
	}
	
}
